export default "__VITE_ASSET__35ba26a2__"